import moment from 'moment';

export const dateFormatter = (date: Date) => moment(date).format('DD-MMM-YYYY');

export const filterTimeHandler = (time: Date, fromDate: Date) => {
  const currentDate = new Date();
  if (!fromDate && dateFormatter(time) === dateFormatter(currentDate)) {
    return time.getTime() > currentDate.getTime();
  }
  if (
    (fromDate && dateFormatter(fromDate) === dateFormatter(currentDate))
    || dateFormatter(time) === dateFormatter(currentDate)
  ) {
    return (
      time.getTime() > currentDate.getTime()
      && time.getTime() > fromDate.getTime()
    );
  }
  if (
    fromDate
    && dateFormatter(fromDate) !== dateFormatter(currentDate)
    && dateFormatter(fromDate) === dateFormatter(time)
  ) {
    return time.getTime() > fromDate.getTime();
  }

  return true;
};

export const filterFromTimeHandler = (time: Date, toDate?: Date) => {
  const currentDate = new Date();
  const selectedDate = new Date(time);
  const currentDateFormat = dateFormatter(currentDate);
  const selectedDateFormat = dateFormatter(selectedDate);

  if (!toDate && currentDateFormat === selectedDateFormat) {
    return currentDate.getTime() < selectedDate.getTime();
  }

  if ((toDate && dateFormatter(toDate) === currentDateFormat) || currentDateFormat === selectedDateFormat) {
    return time.getTime() > currentDate.getTime();
  }

  if (toDate && dateFormatter(toDate) !== currentDateFormat && dateFormatter(toDate) === selectedDateFormat) {
    return time.getTime() < toDate.getTime();
  }

  return currentDate.getTime() < selectedDate.getTime();
};
